import PropTypes from 'prop-types';

import { FIELD_NAMES } from './constants';

export const addressPropType = PropTypes.shape({
  [FIELD_NAMES.CITY]: PropTypes.string,
  [FIELD_NAMES.COMPANY]: PropTypes.string,
  [FIELD_NAMES.COUNTRY_CODE]: PropTypes.string,
  [FIELD_NAMES.EMAIL]: PropTypes.string,
  [FIELD_NAMES.LINE1]: PropTypes.string,
  [FIELD_NAMES.LINE2]: PropTypes.string,
  [FIELD_NAMES.LINE3]: PropTypes.string,
  [FIELD_NAMES.NAME]: PropTypes.string,
  [FIELD_NAMES.PHONE]: PropTypes.string,
  [FIELD_NAMES.POSTAL_CODE]: PropTypes.string,
  [FIELD_NAMES.STATE]: PropTypes.string,
});
